import { createClient } from "tinacms/dist/client";
import { queries } from "./types.js";
export const client = createClient({ cacheDir: "/vercel/path0/tina/__generated__/.cache/1793794348758", url: "https://content.tinajs.io/3.0/content/175bff9f-3302-450a-a51e-b7751ad5397c/github/main", token: "5ba1115a6892329a7e6c9792a2ba51eb6d55209c", queries, errorPolicy: "include" });
export default client;
